/**
 * Fracción del ancho del cuerpo de columna que ocupa cada tarjeta (Leads / Captaciones).
 * 1 = ancho completo (comportamiento anterior). Valores por debajo de 1 dejan márgenes laterales.
 *
 * Reversión: `git revert` del commit que añade este archivo / cambia este valor, o poner 1 y quitar
 * los wrappers con clase `pipeline-card-in-column` en `Pipeline.jsx`.
 */
export const PIPELINE_CARD_WIDTH_RATIO = 0.88;
